<template>
  <div styleName="toggleIcon" v-if="show" @click="toggle">
  </div>
</template>
<script>
import CSSModules from 'vue-css-modules'
export default {
  name: 'toggleIcon',
  mixins: [CSSModules()],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle () {
      this.$emit('toggle')
    }
  }
}
</script>
<style module>
.toggleIcon {
  background: url("@/assets/images/放大视频.svg") left center no-repeat;
  width: 32px;
  height: 32px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
}
</style>
